package com.anjuros.website.templates.template9.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.shared.AnjurosCopyright
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.templates.template9.components.Template9Logo
import com.anjuros.website.templates.template9.modules.Template9Contact
import com.anjuros.website.templates.template9.modules.Template9Social
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColor
import com.anjuros.website.templates.template9.styles.Template9ContainerStyle
import com.anjuros.website.templates.template9.styles.Template9FooterLinkStyle
import com.anjuros.website.templates.template9.util.Template9Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Span

@Composable
fun Template9FooterSection() {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Template9Theme.Secondary.rgb)
            .padding(top = 30.px, bottom = 16.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            modifier = Template9ContainerStyle.toModifier()
                .flexWrap(FlexWrap.Wrap)
                .gap(24.px),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Template9Logo(
                nameColor = Colors.White,
                subtitleColor = Template9Theme.Accent.rgb
            )

            Row(
                modifier = Modifier
                    .flexWrap(FlexWrap.Wrap)
                    .gap(28.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Template9Contact.entries.forEach { contact ->
                    Link(
                        modifier = Modifier.textDecorationLine(TextDecorationLine.None),
                        path = contact.path,
                        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
                    ) {
                        Row(
                            modifier = Modifier.gap(10.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            AnjurosIcon(
                                modifier = Modifier.size(20.px),
                                src = contact.icon,
                                alt = contact.alt
                            )
                            Span(
                                attrs = Template9FooterLinkStyle.toModifier()
                                    .fontFamily(Template9Constants.FONT_FAMILY)
                                    .fontSize(14.px)
                                    .fontWeight(FontWeight.Medium)
                                    .toAttrs()
                            ) {
                                AnjurosText(contact.contact)
                            }
                        }
                    }
                }
            }

            Row(
                modifier = Modifier.gap(10.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Template9Social.entries.forEach { social ->
                    Link(
                        path = social.path,
                        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
                    ) {
                        Box(
                            modifier = Modifier
                                .size(38.px)
                                .borderRadius(50.percent)
                                .backgroundColor(Template9Theme.Primary.getColor()),
                            contentAlignment = Alignment.Center
                        ) {
                            AnjurosIcon(
                                modifier = Modifier.size(18.px),
                                src = social.icon,
                                alt = social.alt
                            )
                        }
                    }
                }
            }
        }

        Box(
            modifier = Template9ContainerStyle.toModifier()
                .height(1.px)
                .margin(top = 24.px)
                .backgroundColor(rgba(255, 255, 255, 0.12))
        )

        AnjurosCopyright(Modifier.margin(top = 14.px))
    }
}
